/**
 * Switch renders a select with different options.
 * The option has to be an array with Objects like { id: 1, label: 'Geländeansicht', ...}
 * currentItem defines the id of the item that should be selected.
 * You also need to pass a handler which get called with the id on select change.
 */

import React, { PropTypes, PureComponent } from 'react';

import './switch.scss';

class Switch extends PureComponent {
  constructor() {
    super();
    this.changeHandlerSelect = this.changeHandlerSelect.bind(this);
  }

  changeHandlerSelect(evt) {
    this.props.changeHandler(evt.target.value);
  }

  render() {
    const options = this.props.items.map(item =>
      <option
        value={item.id}
        key={`switch_option_${item.id}`}
      >
        {item.label}
      </option>
    );

    return (
      <div className="mt-basemap-switch-wrapper text--blue-dark">
        <select
          onChange={this.changeHandlerSelect}
          className="mt-basemap-switch"
          value={this.props.currentItemId}
        >
          {options}
        </select>
      </div>
    );
  }
}

Switch.propTypes = {
  items: PropTypes.array,
  currentItemId: PropTypes.string,
  changeHandler: PropTypes.func,
};

Switch.defaultProps = {
  items: [],
  currentItemId: '',
  changeHandler: () => {},
};

export default Switch;



/** WEBPACK FOOTER **
 ** ./core_components/Switch/index.js
 **/